import { TextInputField } from "evergreen-ui";
import React, { useContext } from "react";
import Button from "src/Components/Button";
import { LanguageStore } from "src/Context/LanguageStore";
import { InputHooksType } from "src/Types/data-types";
import styled from "styled-components";

const Container = styled.form`
  ${(props) => props.theme.whiteBox};
  padding: 0px;
`;
const Title = styled.h1`
  ${(props) => props.theme.title};
  margin-bottom: 0.5rem;
`;

const Body = styled.div`
  padding: 1.5rem;
  width: 100%;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1rem;
  background-color: ${(props) => props.theme.extraLightGreyColor};
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
`;

const ButtonHolder = styled.div``;

interface IProps {
  username: InputHooksType;
  name: InputHooksType;
  onSubmit: any;
  checkUsername: any;
  country: any;
  loading: boolean;
  usernameOk: boolean;
  isLoading: boolean;
}

const SetupUsernamePresenter: React.SFC<IProps> = ({
  username,
  name,
  onSubmit,
  checkUsername,
  usernameOk,
  country,
  loading,
  isLoading,
}) => {
  const { dictionary } = useContext(LanguageStore);
  return (
    <Container>
      <Body>
        <Header>
          {dictionary.step} 2/{country.length > 1 ? "3" : 2}
        </Header>
        <Title>{dictionary.letUsKnowABitAboutYou}</Title>
        <TextInputField {...name} label="Full Name" description="as per IC" />
        <TextInputField
          value={username.value}
          onChange={checkUsername}
          isInvalid={!loading && !usernameOk}
          validationMessage={!loading && !usernameOk && "Username is taken!"}
          label="Username"
          description={dictionary.aUniqueUsername}
        />
      </Body>
      <Footer>
        <ButtonWrapper>
          <ButtonHolder>
            <Button
              label="Next"
              disabled={
                loading ||
                name.value === "" ||
                !usernameOk ||
                username.value === "" ||
                isLoading
              }
              onClick={onSubmit}
            />
          </ButtonHolder>
        </ButtonWrapper>
      </Footer>
    </Container>
  );
};

export default SetupUsernamePresenter;
